import { render, staticRenderFns } from "./collectGoodList.vue?vue&type=template&id=fbbb6974&scoped=true&"
import script from "./collectGoodList.vue?vue&type=script&lang=js&"
export * from "./collectGoodList.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./collectGoodList.vue?vue&type=style&index=0&id=fbbb6974&scoped=true&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "fbbb6974",
  "12983efb"
  
)

export default component.exports